module.exports = __webpack_public_path__ + "img/our-area.fbea0c0.png";